import type { ReactNode } from "react";
import {
    Dialog,
    DialogBody,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog.tsx";
import Icon from "@/components/ui/icon";
import type { Nullable } from "@/types";

// * TL;DR;
// * ToolTip that renders as a modal 😆

type Props = { label: ReactNode; tooltip: Nullable<string> };
export default function ChoiceTooltip({ label, tooltip }: Props) {
    if (!tooltip) return null;

    return (
        <Dialog>
            <DialogTrigger className="reference-tooltip__trigger">
                <Icon name="info-circle" />
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{label}</DialogTitle>
                </DialogHeader>
                <DialogBody className="reference-tooltip__content">
                    <div dangerouslySetInnerHTML={{ __html: tooltip }} className="reference-tooltip__description" />
                </DialogBody>
            </DialogContent>
        </Dialog>
    );
}
